module.exports = __webpack_public_path__ + "img/shareholder-structure.9e7bdd7c.jpeg";